import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";

const NAV = [
  { label: "Home", href: "#top", internal: false },
  { label: "Webdesign", href: "#webdesign", internal: false },
  { label: "Clothing Design", href: "#clothing-design", internal: false },
  { label: "Clothing Brand", href: "#clothing-brand", internal: false },
  { label: "Portfolio", href: "#portfolio", internal: false },
  { label: "Über mich", href: "#ueber-mich", internal: false },
  { label: "Partner", href: "#partner", internal: false },
  { label: "Projekt starten", href: "#kontakt", internal: false },
];

const LEGAL = [
  { label: "Impressum", to: "/impressum", id: "impressum" },
  { label: "Datenschutz", to: "/datenschutz", id: "datenschutz" },
  { label: "AGB", to: "/agb", id: "agb" },
];

export default function Footer() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end end"],
  });
  const wordmarkY = useTransform(scrollYProgress, [0, 1], [120, 0]);
  const wordmarkScale = useTransform(scrollYProgress, [0, 1], [0.92, 1]);

  const go = (href) => (e) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (window.__lenis && el) window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
    else el?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer ref={ref} data-testid="site-footer" className="relative border-t border-black/5 px-6 lg:px-12 pt-20 pb-10 overflow-hidden bg-white world-footer">
      <div className="max-w-[1600px] mx-auto">
        <motion.p
          style={{ y: wordmarkY, scale: wordmarkScale }}
          data-testid="footer-wordmark"
          className="font-display font-bold uppercase tracking-tighter leading-none text-[12vw] text-black/[0.04] select-none whitespace-nowrap origin-bottom"
        >
          Justin WD&amp;C.
        </motion.p>

        <div className="mt-14 grid sm:grid-cols-3 gap-10 text-xs uppercase tracking-[0.22em] text-zinc-500">
          <div className="space-y-3">
            <p className="text-zinc-400">Navigation</p>
            {NAV.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={go(l.href)}
                data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className="block hover:text-ink transition-colors duration-300"
              >
                {l.label}
              </a>
            ))}
          </div>
          <div className="space-y-3">
            <p className="text-zinc-400">Rechtliches</p>
            {LEGAL.map((l) => (
              <Link
                key={l.id}
                to={l.to}
                data-testid={`footer-legal-${l.id}`}
                className="block hover:text-ink transition-colors duration-300"
              >
                {l.label}
              </Link>
            ))}
          </div>
          <div className="space-y-3">
            <p className="text-zinc-400">Marke</p>
            <p className="font-editorial italic normal-case tracking-normal text-sm text-zinc-500">
              Deine Idee. Unsere Umsetzung. Dein Ergebnis.
            </p>
            <p className="text-zinc-400">
              Webdesign · Clothing Design · Brand Aufbau
            </p>
            <Link
              to="/admin/login"
              data-testid="footer-admin-link"
              className="inline-block hover:text-ink transition-colors duration-300"
            >
              Admin
            </Link>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-black/5 flex flex-col sm:flex-row justify-between gap-4 text-[11px] uppercase tracking-[0.25em] text-zinc-400">
          <span>© 2026 JUSTIN WEB DESIGN &amp; CLOTHING</span>
          <span>Made mit Hingabe in Burgheim</span>
        </div>
      </div>
    </footer>
  );
}
